import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import qs from 'query-string';

const Error = () => {
  const { search } = useLocation();
  const { err_info } = qs.parse(search);
  return (
    <Wraper>
      <div>
        <div style={{ textAlign: 'center', margin: '48px auto 0' }}>
          <img className="titleImg" src="https://hk-web.apaylater.net/atome.svg" alt="Atome" />
        </div>
      </div>
      {
        <div className="success_wraper">
          <p className="success_wraper_ok">❌</p>
          {err_info === 'UNAUTHORIZED' ? (
            <>
              <p className="success_wraper_tip1">Your access is restricted</p>
              <p className="success_wraper_tip2">Please contact your platform administrator.</p>
            </>
          ) : (
            <>
              <p className="success_wraper_tip1">Your operation has timed out</p>
              <p className="success_wraper_tip2">If you continue, please exit and reopen the page.</p>
            </>
          )}
        </div>
      }
    </Wraper>
  );
};

const Wraper = styled.div`
  overflow: hidden;
  .success_wraper {
    text-align: center;
    &_ok {
      width: 70px;
      height: 70px;
      color: #fff;
      background-color: #b9e1bd;
      border: 1px solid #69a47e;
      font-size: 35px;
      border-radius: 50%;
      line-height: 65px;
      text-align: center;
      margin: 0 auto;
    }
    &_tip1 {
      font-size: 24px;
      font-weight: 600;
      padding-top: 9px;
      padding-bottom: 13px;
      margin-bottom: 0;
    }
    &_tip2 {
      font-size: 20px;
      font-weight: 600;
      padding-bottom: 13px;
    }
    &_content {
      width: 328px;
      font-size: 14px;
      padding-bottom: 13px;
      margin: 0 auto;
    }
  }
  @media only screen and (max-width: 1000px) {
    .form_area {
      width: 85% !important;
      margin: 0 auto;
    }
    h4 {
      margin-bottom: 15px;
    }
    .input_wraper {
      margin-bottom: 30px;
    }
    h4 {
      font-size: 17px !important;
    }
    .button {
      font-size: 19px;
    }
    h2 {
      font-size: 1.5em;
      margin: 15px 0 !important;
    }
    .desc1,
    .desc2,
    .input_info {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

export default Error;
